import DateFnsUtils from '@date-io/date-fns';
import {Typography} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import PopupRemove from 'components/Popups/PopupRemove';
import {CLEAN} from 'features/edit-course/requirement/types';
import {i18n2} from 'features/i18n/i18n';
import {UPDATE_NOTIFICATION} from 'features/navigation/actions';
import {Field} from 'formik';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';
import ContentGrid from '../components/ContentGrid';
import EditCourseForm from '../components/EditCourseForm';
import useRole from 'components/GenericsHooks/useRoles';
import {Roles} from 'app/Constants';
import useAddOnlineAutomatically from '../hooks/useAddOnlineAutomatically';
import {
  PageProfCourseGridNoEdit,
  PageProfileGridNoEdit,
  PageProfileGrids,
  PageProfileSpacGrid,
} from '../requirement/pages/index';

function TabPanel(props) {
  const {children, value, index, ...other} = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <>{children}</>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const EditCoursePage = (props) => {
  ///Agregar propsTypes
  const addOnlineAutomatically = useAddOnlineAutomatically();
  const dispatch = useDispatch();
  const role = useRole();
  const canEditRequirements =
    role === Roles.AdminHSE ||
    role === Roles.AdminITPS ||
    role === Roles.AdminQA;
  const [typeCourse, setTypeCourse] = useState(props.location.state.typeCourse);
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const initial = [];
  const noEdit = props.location.state.type ? true : false;
  const isSpacCourse = typeCourse === 'SAC';

  const addWith2ParamsOptions = {
    AddedOne: props.location.state.id,
    AddedTwo: null,
    AddedThree: initial,
  };

  useEffect(() => {
    cleanReduxProfiles();
    dispatch({type: 'MODE', payload: noEdit});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cleanReduxProfiles = () => {
    dispatch({type: CLEAN, payload: []});
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const customFields = (e, t) => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid style={{padding: '1%'}} container spacing={3}>
          <Grid item xs={12}>
            <Field
              name="dateVig"
              component={KeyboardDatePicker}
              label={i18n2._('Fecha de instancia')}
              fullWidth
              inputVariant="outlined"
              disableToolbar
              variant="inline"
              views={['year', 'month', 'date']}
              format="dd/MM/yyyy"
              disablePast
              required
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    );
  };

  const changeTypeCourse = (typeCourseParam) => {
    if (typeCourseParam !== typeCourse) {
      setTypeCourse(typeCourseParam);
    }
  };
  //Esto hay que mejorarlo
  return (
    <>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange}>
          <Tab label={i18n2._('Información del curso')} {...a11yProps(0)} />
          <Tab label={i18n2._('Material')} {...a11yProps(1)} />
          <Tab label={i18n2._('Requerimientos')} {...a11yProps(2)} />
          {noEdit && canEditRequirements && (
            <Tab label={i18n2._('Editar requerimientos')} {...a11yProps(3)} />
          )}
          {!noEdit && (
            <Tab
              label={i18n2._('Finalizar edición')}
              onClick={() => {
                setOpen(true);
                setValue(value);
              }}
            />
          )}
          <Tab
            style={{marginLeft: 'auto'}}
            label={i18n2._('Volver')}
            component={Link}
            to={'/Settings'}
            onClick={cleanReduxProfiles}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Box p={3}>
          <EditCourseForm
            id={props.location.state.id}
            noEdit={noEdit}
            changeTypeCourse={(e) => {
              changeTypeCourse(e);
            }}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ContentGrid id={props.location.state.id} noEdit={noEdit} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        {noEdit ? (
          <Box p={1}>
            {!isSpacCourse ? (
              <PageProfileGridNoEdit id={props.location.state.id} />
            ) : (
              <PageProfCourseGridNoEdit id={props.location.state.id} />
            )}
          </Box>
        ) : isSpacCourse ? (
          <Box p={1}>
            <PageProfileSpacGrid
              id={props.location.state.id}
              cancel={() => handleChange(null, 0)}
            />
          </Box>
        ) : (
          <Box p={1}>
            <PageProfileGrids
              id={props.location.state.id}
              cancel={() => handleChange(null, 0)}
            />
          </Box>
        )}
      </TabPanel>
      {noEdit && canEditRequirements ? (
        <TabPanel value={value} index={3}>
          {isSpacCourse ? (
            <Box p={3}>
              <PageProfileSpacGrid
                id={props.location.state.id}
                cancel={() => handleChange(null, 0)}
              />
            </Box>
          ) : (
            <Box p={3}>
              <PageProfileGrids
                id={props.location.state.id}
                cancel={() => handleChange(null, 0)}
              />
            </Box>
          )}
        </TabPanel>
      ) : null}
      {open && (
        <PopupRemove
          open={open}
          setOpen={setOpen}
          promiseToReturn={addOnlineAutomatically}
          CustomFields={(e, t) => customFields(e, t)}
          initialValues={{
            pass: '',
            reason: '',
            dateVig: null,
          }}
          types={addWith2ParamsOptions}
          url={'/Settings'}
          redirect={redirect}
          setRedirect={setRedirect}
          title={i18n2._('Finalizar edición')}
          customPadding={'1%'}
          text={i18n2._(
            'Una vez finalizada la edición ya no se podrá modificar el curso y se crearán las instancias online.',
          )}
          dispatch={dispatch}
          actionType={UPDATE_NOTIFICATION}
          withMessage={false}
        />
      )}
    </>
  );
};

export default EditCoursePage;
